import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import config from './config'
import ToggleButton from 'vue-js-toggle-button'
import VModal from 'vue-js-modal'
import beforeunloadAlert from './helpers/beforeunloadAlert'

Vue.use(ToggleButton)
Vue.use(VModal)

window.axios = require('axios')
window.config = config

beforeunloadAlert()
//Vue.prototype.$videojs = require('video.js')
//import 'video.js/dist/video-js.min.css'
//require('videojs-youtube')

import '@/assets/styles/app.css'

Vue.config.productionTip = false

const files = require.context('./components/.', true, /^\.\/Editor([A-Za-z]+)\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('DropdownMenu', require('./components/DropdownMenu.vue').default)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
